import React from "react";
import { useSelector } from "react-redux";

export default function AboutClinic() {
  const data = useSelector((state) => state.main.data?.mainData?.[0]);
  return (
    <section className="about-clinic-home" id="clinic">
      <div
        className="head-title"
        data-aos="fade-left"
        data-aos-duration="1000"
        data-aos-offset="300"
      >
        <span>عن العيادة</span>
      </div>
      <div className="container">
        {" "}
        <div className="right">
          <div
            className="text"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-offset="400"
          >
            <span>{data?.about_clinc}</span>
          </div>
          <div className="bottom" data-aos="fade-in" data-aos-offset="200">
            <div className="one"></div>
            <div className="two"></div>
          </div>
        </div>
        <div className="left">
          <div className="effects">
            <div
              className="effect one"
              data-aos="fade-up-right"
              data-aos-duration="1000"
              data-aos-offset="300"
            ></div>
            <div
              className="effect two"
              data-aos="fade-up-left"
              data-aos-duration="1000"
              data-aos-offset="300"
            ></div>
            <div
              className="effect thee"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-offset="300"
            ></div>
          </div>
          <div className="images">
            <div className="image one">
              <img
                src={`https://api.atharalfarasha.com/public/hakim/${data?.clinc_pic_1}`}
                alt=""
              />
            </div>
            <div className="image two">
              {" "}
              <img
                src={`https://api.atharalfarasha.com/public/hakim/${data?.clinic_pic_2}`}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
